export default __webpack_public_path__ + "static/media/defaultBcg.0bb3fe0a.jpeg";